import { mainAPI, handleApiError } from "../api";

import {
  ModeratorsRequest,
  ModeratorResponse,
  CreateModeratorRequest,
} from "../types/api/moderators";

const path = `admin/${process.env.REACT_APP_API_VERSION}/moderators`;

// Модераторы - Получить список
export function fetchModerators(params: ModeratorsRequest) {
  return mainAPI.get<ModeratorResponse[]>(`/users/${path}`, { params }).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data,
        totalCount: countHeader,
      });
    },
    (error) => handleApiError(error)
  );
}

// Модераторы - Создать
export function createModerator(data: CreateModeratorRequest) {
  return mainAPI
    .post<ModeratorResponse>(`/users/${path}`, data, {
      skipErrorHandling: true,
    })
    .then(
      (res) => {
        return Promise.resolve(res.data as ModeratorResponse);
      },
      (error) => {
        let apiError = "Произошла ошибка";

        if (error.response?.data?.errors) {
          apiError = Array.isArray(error.response.data.errors)
            ? error.response.data.errors.join(", ")
            : error.response.data.errors;
        } else if (error.response?.data?.detail) {
          apiError = error.response.data.detail;
        } else if (error.response?.data?.message) {
          apiError = error.response.data.message;
        } else if (error.data?.errors) {
          apiError = Array.isArray(error.data.errors)
            ? error.data.errors.join(", ")
            : error.data.errors;
        } else if (error.message) {
          apiError = error.message;
        }

        return Promise.reject(new Error(apiError));
      }
    );
}

// Модераторы - Удалить
export function deleteModerator(ids: string[]) {
  return mainAPI.post(`/users/${path}/delete`, { ids: ids }).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => handleApiError(error)
  );
}

// Модераторы - Получить свой аккаунт
export function fetchProfile() {
  const profilePath = `users/admin/${process.env.REACT_APP_API_VERSION}`;

  return mainAPI.get<ModeratorResponse>(`${profilePath}/account`).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => handleApiError(error)
  );
}
